<template>
  <div class="hoverk">
    <!-- <div>{{text.text1}}<br>{{text.text2}}</div> -->
    <div>各证券公司支持该功能情况不统一</div>
  </div>
</template>

<script>
export default {
    props:{
        text:{
            default:'',
            type:Object,
        }
    }
}
</script>

<style scoped>
.hoverk{
    pointer-events:none; 
    padding: 3px 6px;
    border: 1px solid #4d4d4d;
    background: white;
    font-size: 14px;
}
</style>